import { PropTypes } from "prop-types"

export const COLUMN_SHAPE = PropTypes.shape({
  id: PropTypes.string.isRequired,
  align: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
  getter: PropTypes.func.isRequired,
  formatter: PropTypes.func,
})
